import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  addToBasket: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.small,
    },
    small: {
      marginBottom: 0,
      flexDirection: "row",
      marginLeft: "auto",
      justifyContent: "flex-end",
    },
  }),
  submit: {
    marginLeft: theme.spacing.xsmall,
    flexDirection: "row",
    flexShrink: 0,
    justifyContent: "center",
  },
  loader: createResponsiveStyles({
    base: {
      marginBottom: 10,
      marginTop: -20,
    },
    small: {
      margin: 0,
    },
  }),
});
